import {ApplicationDashboard} from "@flexinet/ui-components";
import {structure} from "../config";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";

export const PortalDashboard = () => {

    const {allowedActions} = useVerifiedPermissions()

    structure.columns.forEach(column => {
        column.items = column.items.filter(item => allowedActions.includes(item.rbac as string))
    })


    return (
        <ApplicationDashboard structure={structure}/>
    );
};
